import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheEuropeanStandardInAssetSafeguarding from "./sections/TheEuropeanStandardInAssetSafeguarding";
import RealTimeEcosystemMetrics from "./sections/RealTimeEcosystemMetrics";
import TheCopytradingEdge from "./sections/TheCopytradingEdge";
import OnboardingWorkflow from "./sections/OnboardingWorkflow";
import EliteMarketInsights from "./sections/EliteMarketInsights";
import SecureYourStrategyCall from "./sections/SecureYourStrategyCall";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheEuropeanStandardInAssetSafeguarding />
      <RealTimeEcosystemMetrics />
      <TheCopytradingEdge />
      <OnboardingWorkflow />
      <EliteMarketInsights />
      <SecureYourStrategyCall />
      <Footer />
    </div>;
}